import WebFont from "webfontloader";
import { TextTypes } from "react-exsurge";
import { fontsToLoad as webfonts } from './googleFonts';
export const fontKeys = [""]
  .concat(Object.keys(TextTypes))
  .map(key => (key ? key + "Font" : "font"));

export const fonts = [
  "Garamond Premier Pro",
  "Barroux",
  "Plantin MT Pro",
  "Times New Roman",
];

export const defaultLocalFont = 'Garamond Premier Pro';
export const defaultWebFont = 'EB Garamond';

export const webFontsPromise = new Promise((resolve, reject) => {
  const loadedFonts = Object.fromEntries(webfonts.map(name => [name, null]));
  const areAllLoaded = () => Object.entries(loadedFonts).every(([name, loaded]) => typeof loaded === 'boolean');
  const resolveIfLoaded = () => {
    if (areAllLoaded()) resolve(Object.entries(loadedFonts).filter(([name, loaded]) => loaded).map(([name]) => name));
  }
  WebFont.load({
    google: {
      families: webfonts,
    },
    classes: false,
    fontactive: (familyName, fvd) => {
      if (fvd === "n4") {
        loadedFonts[familyName] = true;
        resolveIfLoaded();
      }
    },
    fontinactive: (familyName, fvd) => {
      if (fvd === "n4") {
        console.info(`failed to load font: ${familyName}`)
        loadedFonts[familyName] = false;
        resolveIfLoaded();
      }
    },
  });
});